module.exports = __webpack_public_path__ + "media/images/partner-7-60d0efe72c7cd2b30a33bbd08b2929a1.png";